import { z } from "zod";
import { VictimStatusZ } from "./enums/victim-status";

export const VictimQueryZ = z.object({
  status: VictimStatusZ.optional(),
  country: z.string().optional(),
  region: z.string().optional(),
  from: z.string().datetime().optional(),
  to: z.string().datetime().optional(),
});
export type VictimQuery = z.infer<typeof VictimQueryZ>;